module.exports = __webpack_public_path__ + "static/media/mob12.cf692d34.webp";